module.exports = __webpack_public_path__ + "media/images/hybrid-raid-manager-screenshot-2-b87b3c4c908890d4e45c443995cd71de.jpg";